export enum NotificationClassificationEnum {
  UNK = 'unknown',
  EMAIL = 'email',
  SMS = 'sms'
}
